// import React from 'react';
// import '../Offers/Offer.css';
// import Item from "../Item/Item";
// //import bg from '../Assets/Frontend_Assets/bg.jpg';
// //import { useNavigate } from "react-router-dom";

// const Offer = () => {
// //  const navigate = useNavigate(); 

//   return (
//     // <div className="offer-banner">
//     //   <img src={bg} alt="Offer" />

//     //   <div className="overlay"></div>

//     //   <div className="offer-content">
//     //     <h1 className='subheading'>WELCOME TO KHAN COLLECTION</h1>
//     //     <p className='h2'>EXTRAVAGANT FASHION FOR THE INDEPENDENT URBAN WOMAN/MEN</p>
//     //     <p className='h3'>HANDCRAFTED. MADE TO MEASURE</p>

//     //     <button onClick={() => navigate("/about")}>
//     //       About Us
//     //     </button>
//     //   </div>
//     // </div>
  

// <div className="shopcategory-products four-grid">
//   {trendingProducts.map(p => (
//     <Item
//       key={p.product_id}
//       id={p.product_id}
//       image={p.image || placeholder}
//       product_name={p.product_name}
//       productCode={p.product_code}
//       pieces={p.pieces?.length ? `${p.pieces.length} Piece` : ""}
//       clothType={p.cloth_type}
//       type={p.type?.toUpperCase()}
//       isNew={p.is_new}
//       trending={p.trending}
//       new_price={p.new_price}
//       old_price={p.old_price}
//     />
//   ))}
// </div>
//   );
// };

// export default Offer;
import React, { useEffect, useState } from 'react';
import '../Offers/Offer.css';
import Item from "../Item/Item";
import BASE_URL from "../../Config/api";

const Offer = () => {
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ API CALL
  useEffect(() => {
    const fetchTrending = async () => {
      try {
        const res = await fetch(`${BASE_URL}/trending-products`);
        const data = await res.json();

        setTrendingProducts(data);
      } catch (err) {
        console.error("Error fetching trending products:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTrending();
  }, []);

  return (
    <div className='main-t'>
      {/* <h2 className="section-title tt">🔥 Trending Products</h2> */}

      <div className="shopcategory-products four-grid">
        {loading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div className="skeleton-card" key={i} />
            ))
          : trendingProducts.map(p => (
              <Item
                key={p.product_id}
                id={p.product_id}
                image={p.image}
                product_name={p.product_name}
                productCode={p.product_code}
                pieces={p.pieces?.length ? `${p.pieces.length} Piece` : ""}
                clothType={p.cloth_type}
                type={p.type?.toUpperCase()}
                isNew={p.is_new}
                trending={p.trending}
                new_price={p.new_price}
                old_price={p.old_price}
              />
            ))
        }
      </div>
    </div>
  );
};

export default Offer;